export default __webpack_public_path__ + "static/Artificial_Light_Outdoor_1920kbps-3da35bcd53f5958d1a0256440679bbd8.avif";